import { Component, Input } from '@angular/core';
import { TipoModalObservacion } from "@shared/enums/TipoModalObservacion";
import { TipoExportarExcel } from '@shared/enums/TipoExportar';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-motivos-observaciones',
  templateUrl: './motivos-observaciones.component.html'
})
export class MotivosObservacionesComponent  {
  @Input() titulo: string = "Motivo";
  @Input() tipoObservacion: TipoModalObservacion;
  @Input() motivos: string;

  protected readonly TipoModalObservacion = TipoModalObservacion;

  constructor(public activeModal:NgbActiveModal) { }

  onClick(tipo: TipoExportarExcel) {
    this.activeModal.close(tipo);
  }
}
